import { useEffect, useRef } from "react";
import { MEDIA_URL_REFRESH_MS } from "../../Services/MediaAssetService";

const CHECK_INTERVAL_MS = 60 * 1000;

/**
 * The signed URLs in an article's media list expire. A page that stays open keeps working by reloading that
 * list in time — only while somebody is actually looking at the tab, and right away when they come back to
 * one that was left open for longer.
 */
export const useMediaUrlRefresh = (reloadMedia: () => void): void => {
    const reloadMediaRef = useRef(reloadMedia);
    reloadMediaRef.current = reloadMedia;

    useEffect(() => {
        let refreshedAt = Date.now();
        const refreshWhenDue = () => {
            if (document.visibilityState === "visible" && Date.now() - refreshedAt >= MEDIA_URL_REFRESH_MS) {
                refreshedAt = Date.now();
                reloadMediaRef.current();
            }
        };
        const timer = window.setInterval(refreshWhenDue, CHECK_INTERVAL_MS);
        document.addEventListener("visibilitychange", refreshWhenDue);
        return () => {
            window.clearInterval(timer);
            document.removeEventListener("visibilitychange", refreshWhenDue);
        };
    }, []);
};
